import { BorderRadius, Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const ConnectShineBannerContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 200px;
  padding: ${Spacing.S16} 0 0 ${Spacing.S24};
  border-radius: ${BorderRadius.R12};
  background-color: ${Color.Green100};
`

export const ContentWrapper = styled.div`
  display: flex;
  flex: 1;
  gap: ${Spacing.S12};
  justify-content: space-between;
  min-height: 100px;
  overflow: visible;
`

export const IllustrationContainer = styled.div`
  align-self: flex-end;
  flex-shrink: 0;
  height: clamp(80px, 25vh, 135px);
  margin-left: auto;

  svg {
    width: auto;
    height: 100%;
  }
`

export const CtaWrapper = styled.div`
  margin: auto 0;
`
